/*!
 * Copyright Optimus Ride 2019
 */

import firebase from 'firebase';

import * as jspb from 'google-protobuf';

export function snapshotToProtobuf<T extends jspb.Message>(
    snapshot: firebase.firestore.DocumentSnapshot,
    conversionFunction: (a: Uint8Array) => T): T {
  const data = snapshot.data();
  const buff = data ? data.payload.toUint8Array() : new Uint8Array();
  return conversionFunction(buff);
}

export function dataToProtobuf<T extends jspb.Message>(
  data: firebase.firestore.DocumentData,
  conversionFunction: (a: Uint8Array) => T): T {
  const buff = data.payload.toUint8Array();
  return conversionFunction(buff);
}
